import axios from '../plugins/axios'

const API_URL = process.env.VUE_APP_API_URL + '/tracks/'
class TracksAPI {
  list(query) {
    return axios
      .get(API_URL, { params: {
        from: query.fromDate && query.fromDate.toISOString(),
        to: query.toDate && query.toDate.toISOString(),
        motorbike: query.motorbike,
      }})
      .then(response => {
        return response.data
      })
  }
  edit(id, data) {
    return axios
      .put(API_URL + id, {
        motorbike: data.motorbike && data.motorbike._id
      })
      .then(response => {
        return response.data
      })
  }
}
export default new TracksAPI()